<template>
  <div>
    <Breadcrumb :title="'Information Tracker Upload'"></Breadcrumb>
    <div class="row no-gutters">
      <div class="col">
        <button
          class="btn btn-primary"
          style="float:right;"
          @click.prevent="downloadTemplate"
        >Download Template</button>
        <button
          class="btn btn-secondary"
          style="float:right;margin-right:10px;"
          @click.prevent="backtoInfoTracker"
        >
          <span class="k-icon k-i-undo"></span> &nbsp;Back to Information Tracker
        </button>
      </div>
    </div>
    <div class="row">
      <br />
    </div>
    <BaseAuditDropzone
      ref="ParentFileUploaded"
      :id="'InfoTrackerdropzone'"
      :acceptedFileTypes="SheetJSFT"
      @change="_change"
      @Remove="ClearForm"
      :File="inputfile"
      :UploadType="FileUploadType"
    ></BaseAuditDropzone>
    <br />
    <br />
    <div v-show="displayPage">
      <div class="row no-gutters">
        <div class="col">
          <div id="customerrors" class="alert alert-danger" v-if="customerrors.length>0">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="error in customerrors" :key="error">{{ error }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col">
          <div class="form-row">
            <div class="col-md-12">
              <BaseGrid
                :mode="'editform'"
                :config="InformationTrackerUploadGridConfig"
                :data="dataInfoTrackerExcel"
                @DeleteItem="DeleteDIfromGrid"
              >
                <!-- @EditItem="EditPartner"  -->
              </BaseGrid>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <br />
      </div>
      <div class="row no-gutters" style="float: right;">
        <button
          type="button"
          id="btnSave"
          class="btn btn-primary"
          :disabled="!isValid||customerrors.length>0||dataInfoTrackerExcel.length<=0"
          @click="SaveInfoTracker"
        >Save</button>
      </div>
      <div class="row no-gutters" style="float: right;">
        <button
          type="button"
          id="btnSave"
          class="btn btn-secondary"
          @click.prevent="validateInfoTracker"
        >Validate</button>
      </div>
      <div class="row">
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import customAxios from "@/services/customAxios.js";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import VestingScheduleDatesMixin from "@/mixins/VestingScheduleDatesMixin.js";

import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";

import sheetJSConfig from "@/configs/sheetJS.js";
import { isNullOrUndefined } from "util";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import BaseModelInformationTracking from "@/models/BaseModelInformationTracking.js";
import XLSX from "xlsx";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";

import { mapActions, mapState, mapGetters } from "vuex";
import { InformationTrackerUploadGridConfig } from "./InfoTrackeruploadconfig.js";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";

export default {
  components: {
    BaseGrid,
    Breadcrumb,
    BaseAuditDropzone
  },
  mixins: [apiUtil, funcUtil, VestingScheduleDatesMixin,DocumentManagerMixin],
  data() {
    return {
      data: "",
      inputfile: {
        UploadFile: {}
      },
      //UploadFile:excelfile,
      displayPage: false,
      FileUploadType: {
        AllowMultiple: "false"
      },
      SheetJSFT: sheetJSConfig.fileType,
      InformationTrackerUploadGridConfig: InformationTrackerUploadGridConfig,
      dataInfoTrackerExcel: [],
      PartnerAPIData: [],
      InvestmentAPIData: [],
      isValid: false,
      customerrors: [],
      dropdowns: {
        // UnitType: { model: "", dataSource: [] },
        // VestingType: { model: "", dataSource: [] },
        PaymentMethod: { model: "", dataSource: [] }
      },
      bulkUploadAuditConfig: bulkUploadAuditConfig
    };
  },
  computed: {
    ...mapState("postModule", ["response"]),
    ...mapGetters("getModule", [
      "getAllItemFilter",
      "withFilter",
      "getLocalInputControls"
    ])
  },
  methods: {
    ...mapActions("postModule", ["CreateAllItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),
    _suppress(evt) {
      evt.stopPropagation();
      evt.preventDefault();
    },
   created() {
        this._setVmInApiUtil(this.$root);
    },
    downloadTemplate() {
    // let token = localStorage.getItem("eum")
    //       let tokenstr = `Bearer ${token}`
         
           let templateUrl = getUrl("InfoTrackerExcel");
           let templateFileName = getFileName("InfoTrackerExcel");
           
            
           this.$http({
              url: templateUrl,
              method: 'GET'
              // ,headers: {
              //   'Authorization': tokenstr
              // },
              ,responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });
    },

    _drop(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      const files = evt.BaseModelTransfer.files;
      if (files && files[0]) this._file(files[0]);
    },
    _change(evt) {
      const files = this.inputfile.UploadFile[0];
      if (files) this._file(files);
    },
    _export(evt) {
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(wb, "sheetjs.xlsx");
    },
    backtoInfoTracker: function() {
      this.$router.push("/admin/tracker");
    },
    _file(file) {
      /* Boilerplate to set up FileReader */
      try {
        const self=this;
        const XLSX = require("xlsx");
        const reader = new FileReader();
        reader.onload = e => {
          /* Parse data */
          //const bstr = e.target.result;
          let binary = "";
          let bytes = new Uint8Array(e.target.result);
          let length = bytes.byteLength;

          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          const bstr = binary;
          const wb = XLSX.read(bstr, {
            type: "binary"
          });
          /* Get Partner  data */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws, {
            range: sheetJSConfig.template.header - 1,
            header: 1
          });
          console.log(data);
          data.splice(0, 1);
          if (data && data.length) {
            //get partner and Program
            let response = this.getAllItemFilter({
              Partner: {
                config: BaseModelPartner
              },
              Program: {
                config: BaseModelProgram
              }
            });
            if (response) {
              this.PartnerAPIData = response.Partner;
              this.ProgramAPIData = response.Program;
            }
            //if (this.HeaderRow != "") {
            this.displayPage = true;

            var InfoTrackerExcelArr = [];
            var count = 1;
            for (var i = 0; i < data.length; i++) {
              var InfoTrackerExcelObj = {};
              InfoTrackerExcelObj.InfoTrackerKey = count++;
              InfoTrackerExcelObj.ProgramProgramId = data[i][0];
              //   InfoTrackerExcelObj.LastCompleted = moment(
              //     new Date(Math.round((data[i][13] - 25569) * 86400 * 1000))
              //   ).format("MM/DD/YYYY");
              InfoTrackerExcelObj.PartnerPartnerId = data[i][2];

              if (data[i][4]) {
                InfoTrackerExcelObj.SignaturePage = this._firstLetterToUpper(
                  data[i][4].toString()
                );
              }
              if (data[i][5]) {
                InfoTrackerExcelObj.Receive83b = this._firstLetterToUpper(
                  data[i][5]
                );
              }
              if (data[i][6]) {
                InfoTrackerExcelObj.Receive83bFiledWithIRS = this._firstLetterToUpper(
                  data[i][6]
                );
              }
              InfoTrackerExcelObj.AmountOwed = 0;
              InfoTrackerExcelObj.Payment = data[i][7];
              InfoTrackerExcelObj.MethodofPayment = data[i][8];
              InfoTrackerExcelObj.CheckNumber = data[i][9];
              InfoTrackerExcelObj.DateDeposited = self._getExcelPlatformCode(data[i][10]);
              // moment(
              //   new Date(Math.round((data[i][10] - 25569) * 86400 * 1000))
              // ).format("MM/DD/YYYY");

              InfoTrackerExcelObj.DateWired = self._getExcelPlatformCode(data[i][11]);
              // moment(
              //   new Date(Math.round((data[i][11] - 25569) * 86400 * 1000))
              // ).format("MM/DD/YYYY");
              //Get Vesting Dates
              InfoTrackerExcelArr.push(InfoTrackerExcelObj);
            }
            this.dataInfoTrackerExcel = InfoTrackerExcelArr;
            this.getPartnerDetails();
            this.getProgramDetails();

            var grid = $("#InformationTrackerUploadGrid").data("kendoGrid");

            grid.dataSource.data(this.dataInfoTrackerExcel);

            console.log(JSON.stringify(this.dataInfoTrackerExcel));
          } else {
            this._AlertPopup("Template is Empty", "error").then(result => {});
          }

          /* Update state */
          //this.data = data;
          //console.log(JSON.stringify(data));
        };
        reader.readAsArrayBuffer(file);
      } catch (ex) {
        console.log(ex);
        //this.$Progress.fail();
      }
    },
    getPartnerDetails: function() {
      let partner = this.PartnerAPIData.slice();
      let dataInfoTrackerExcel = this.dataInfoTrackerExcel.slice();

      for (let i = 0; i < dataInfoTrackerExcel.length; i++) {
        if (dataInfoTrackerExcel[i].PartnerPartnerId) {
          var result = partner.filter(function(obj) {
            if (obj.PartnerID) {
              return (
                obj.PartnerID.toString()
                  .trim()
                  .toLowerCase() ==
                dataInfoTrackerExcel[i].PartnerPartnerId.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (result) {
            dataInfoTrackerExcel[i].PartnerTitle = result.FullName;
            dataInfoTrackerExcel[i].PartnerId = result.Id;
          }
        }
      }

      this.dataInfoTrackerExcel = dataInfoTrackerExcel;
    },

    getProgramDetails: function() {
      let Program = this.ProgramAPIData.slice();
      let dataInfoTrackerExcel = this.dataInfoTrackerExcel.slice();

      for (let i = 0; i < dataInfoTrackerExcel.length; i++) {
        if (dataInfoTrackerExcel[i].ProgramProgramId) {
          var result = Program.filter(function(obj) {
            if (obj.ProgramID) {
              return (
                obj.ProgramID.toString()
                  .trim()
                  .toLowerCase() ==
                dataInfoTrackerExcel[i].ProgramProgramId.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (result) {
            dataInfoTrackerExcel[i].ProgramTitle = result.Title;
            dataInfoTrackerExcel[i].ProgramAlias = result.Alias;
            dataInfoTrackerExcel[i].ProgramId = result.Id;
          }
        }
      }
      this.dataInfoTrackerExcel = dataInfoTrackerExcel;
    },

    DeleteDIfromGrid: function(e) {
      //e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message, "DELETE").then(result => {
        if (result.value) {
          var gview = window
            .$("#InformationTrackerUploadGrid")
            .data("kendoGrid");
          var dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );
          //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
          //alert(JSON.stringify(dataItem));
          let objIndex = this.dataInfoTrackerExcel.findIndex(
            obj => obj.InfoTrackerKey == dataItem.InfoTrackerKey
          );
          this.dataInfoTrackerExcel.splice(objIndex, 1);
          var grid = $("#InformationTrackerUploadGrid").data("kendoGrid");
          grid.dataSource.data(this.dataInfoTrackerExcel);
        }
      });
    },

    SaveInfoTracker: function() {
      const self = this;
      let InfoTrackerCreateObject = {
        InformationTracker: {
          config: BaseModelInformationTracking,
          createData: this.dataInfoTrackerExcel.slice()
        }
      };
      //this._createAllItems(NewPartnerobject).then(addnewpartner => {
      //let loader = this.$loading.show();
      self._APICrudPopup("APICrudpopup");
      this.CreateAllItems(InfoTrackerCreateObject)
        .then(response => {
          console.log(response);
          // self._AlertPopup(
          //   "Information Tracker data saved successfully",
          //   "success"
          // );
             /** AUDIT DOCUMENT UPLOAD **/
          let FileUpload = [];
          let senderObj = {};
          //senderObj.Id = this.count++;
          let realfileName = this.inputfile.UploadFile[0].name;
         // senderObj.File = self._appendDatewithExcelName(fileName);
          senderObj.File = this.inputfile.UploadFile[0].upload.uuid
          senderObj.RealFileName = realfileName;
          senderObj.FileContent = this.inputfile.UploadFile[0];
          FileUpload.push(senderObj);
          this.UploadBulkAditFilesToDB(FileUpload)
                .then(response => {
                self._AlertPopup("Information Tracker data saved successfully", "success");
                })
                .catch(error => {
                self._AlertPopup("Some Error Occurred!", "info");
                })
                .finally(() => {
                //loader.hide();
                });
            /** AUDIT DOCUMENT UPLOAD END */
          this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
        })
        .catch(error => {
          self._AlertPopup("Some Error Occurred!", "info");
        })
        .finally(() => {
          //loader.hide();
        });
    },
    ClearForm() {
      this.dataInfoTrackerExcel = [];
      this.displayPage = false;
      this.customerrors = [];
      this.isValid = false;
    },

    validateInfoTracker() {
      let self = this;
      let ProgramApiData = self.withFilter(BaseModelProgram.list);
      let PartnerApiData = self.withFilter(BaseModelPartner.list);
      var chkError = {
        reqProgramID: true,
        rePartnerId: true,
        reqSignaturePage: true,
        reqReceive83b: true,
        reqReceive83bFiledWithIRS: true,
        reqPaymentMethod: true
      };
      self.isValid = true;
      self.customerrors = [];
      self.dataInfoTrackerExcel.forEach((ele, i) => {
        self.Columns = [];
        let programIndex = ProgramApiData.findIndex(
          f => f.ProgramID == ele.ProgramProgramId
        );
        if (
          ele.ProgramProgramId == "" ||
          isNullOrUndefined(ele.ProgramProgramId) ||
          programIndex < 0
        ) {
          self.Columns.push({ column: "ProgramProgramId", row: i });
          if (chkError.reqProgramID) {
            chkError.reqProgramID = false;
            self.customerrors.push("Program ID is Empty or Invalid.");
          }
        }
        let pIndex = PartnerApiData.findIndex(
          f => f.PartnerID == ele.PartnerPartnerId
        );
        if (
          ele.PartnerPartnerId == "" ||
          isNullOrUndefined(ele.PartnerPartnerId) ||
          pIndex < 0
        ) {
          self.Columns.push({ column: "PartnerPartnerId", row: i });
          if (chkError.rePartnerId) {
            chkError.rePartnerId = false;
            self.customerrors.push("Partner ID is Empty or Invalid.");
          }
        }

        if (
          ele.SignaturePage == "" ||
          isNullOrUndefined(ele.SignaturePage) ||
          (ele.SignaturePage != "Received" &&
            ele.SignaturePage != "Not Received")
        ) {
          self.Columns.push({ column: "SignaturePage", row: i });
          if (chkError.reqSignaturePage) {
            chkError.reqSignaturePage = false;
            self.customerrors.push("Signature Page is Empty or Invalid.");
          }
        }
        if (
          ele.Receive83b == "" ||
          isNullOrUndefined(ele.Receive83b) ||
          (ele.Receive83b != "Received" && ele.Receive83b != "Not Received")
        ) {
          self.Columns.push({ column: "Receive83b", row: i });
          if (chkError.reqReceive83b) {
            chkError.reqReceive83b = false;
            self.customerrors.push("83(b) is Empty or Invalid.");
          }
        }
        if (
          ele.Receive83bFiledWithIRS == "" ||
          isNullOrUndefined(ele.Receive83bFiledWithIRS) ||
          (ele.Receive83bFiledWithIRS != "Received" &&
            ele.Receive83bFiledWithIRS != "Not Received")
        ) {
          self.Columns.push({ column: "Receive83bFiledWithIRS", row: i });
          if (chkError.reqReceive83bFiledWithIRS) {
            chkError.reqReceive83bFiledWithIRS = false;
            self.customerrors.push("83(b) Filed With IRS is Empty or Invalid.");
          }
        }
        let methodofPaymentIndex = self.dropdowns.PaymentMethod.dataSource.findIndex(
          f => f.Option == ele.MethodofPayment
        );
        if (
          ele.MethodofPayment == "" ||
          isNullOrUndefined(ele.MethodofPayment) ||
          methodofPaymentIndex < 0
        ) {
          self.Columns.push({ column: "MethodofPayment", row: i });
          if (chkError.reqPaymentMethod) {
            chkError.reqPaymentMethod = false;
            self.customerrors.push("MethodofPayment is Empty or Invalid.");
          }
        }

        self.Columns.push({ column: "Validation", row: i });

        if (self.Columns.length != 1 && self.isValid) {
          self.isValid = false;
        }
        self.ValidateImportData("InformationTrackerUploadGrid", self.Columns);
      });
    },

    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(BaseModelInputControl.list);
      Object.keys(self.dropdowns).forEach(key => {
        self.dropdowns[key].dataSource = response[key];
      });
    }
  },

  mounted() {
    this.getInputControls();
  }
};
</script>


